module.exports = __webpack_public_path__ + "static/media/appart-post.fb7f6906.jpg";